import { createSelector } from "reselect";

const getEnum = state => state.get("enumReducer");

export const selectActions = createSelector([getEnum], enums => {
  return enums.get("actions").toArray();
});
